import {
    ModalDialog,
    ModalDialogBody,
    ModalDialogCloseButton,
    ModalDialogContent,
    ModalDialogHeader,
    ModalDialogNav,
    ModalDialogTitle,
} from '@vp/swan';
import BusinessNameDetail from './BusinessNameDetail';
import type { BusinessName } from '../../pages/BusinessNameGeneratorPage/components/BusinessNameResults/BusinessNameResults';

interface BusinessNameModalProps {
    businessName: BusinessName;
    onDismiss: () => void;
    trackingEventDetails: {
        category: string;
    };
    keyword?: string;
    industryKeywords?: string[];
}

const BusinessNameModal = ({
    businessName,
    onDismiss,
    trackingEventDetails,
    keyword,
    industryKeywords,
}: BusinessNameModalProps) => {
    return (
        <ModalDialog
            variant="panel-right"
            isOpen={!!businessName}
            onRequestDismiss={() => onDismiss()}
            bodyWidth="standard"
            aria-labelledby="modal-title"
        >
            <ModalDialogContent>
                <ModalDialogNav>
                    {/* TODO: Deprecated prop accessibleText */}
                    {/* eslint-disable-next-line @vp/swan/no-deprecated */}
                    <ModalDialogCloseButton accessibleText="Close" />
                </ModalDialogNav>
                <ModalDialogHeader>
                    <ModalDialogTitle id="modal-title">{businessName.name}</ModalDialogTitle>
                </ModalDialogHeader>
                <ModalDialogBody marginBottom={0}>
                    <BusinessNameDetail
                        businessName={businessName}
                        trackingEventDetails={trackingEventDetails}
                        keyword={keyword}
                        industryKeywords={industryKeywords}
                    />
                </ModalDialogBody>
            </ModalDialogContent>
        </ModalDialog>
    );
};

export default BusinessNameModal;
